export default __webpack_public_path__ + "static/media/ConorPhoto.c24e9d33.svg";